var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ListingSettingsHeader", {
    attrs: {
      filters: _vm.filters,
      searchable: _vm.searchable,
      searchValue: _vm.searchValue
    },
    on: { selectFilter: _vm.updateActiveFilters, search: _vm.search },
    scopedSlots: _vm._u([
      {
        key: "filters",
        fn: function() {
          return _vm._l(_vm.getActiveFilters, function(activeFilter) {
            return _c(
              activeFilter.component,
              _vm._b(
                {
                  key: activeFilter.code,
                  tag: "component",
                  staticClass: "listing-table-filters__item",
                  attrs: { filter: activeFilter },
                  on: {
                    "update:displayDropdown": function(value) {
                      activeFilter.displayDropdown = value
                    },
                    updateFilter: function(values) {
                      return _vm.updateFilter(activeFilter, values)
                    },
                    removeFilter: function($event) {
                      return _vm.updateActiveFilters(activeFilter, false)
                    }
                  }
                },
                "component",
                activeFilter,
                false
              )
            )
          })
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }